export class ProductCard extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  static get requiredElements () {
    return ['media']
  }

  connectedCallback () {
    super.connectedCallback()

    this.touchX = null
    this.touchY = null
    this.previousSwipeDirection = null
    this.currentSwipeDirection = null
    this.currentIndex = 0

    this.currentUrl = window.location.href
  }

  setupListeners () {
    super.setupListeners()
    if (this.isInsideCarousel) return
    this.listeners.add(this, 'touchstart', this.handleTouchStart.bind(this))
    this.listeners.add(this, 'touchmove', this.handleTouchMove.bind(this))

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    const isQuickSearchProductCard = this.hasAttribute(
      'data-klevu-quick-product-card',
    )

    let target = event.target.closest('[id^="product-"]')

    // The target will differ for quick search product cards vs PLP cards.
    if (isQuickSearchProductCard) {
      target = event.target.closest('[data-klevu-quick-product-card]')
    }

    if (!event.target.closest('a')) return

    if (!isQuickSearchProductCard) {
      const urlWithoutHash = this.currentUrl
        .split('#')
        .slice(0, 1)
        .join()
      window.history.replaceState(
        {},
        '',
        `${urlWithoutHash}#${target.getAttribute('id')}`,
      )
    }

    const productId = this.getAttribute('data-product-id')
    const variantId = this.getAttribute('data-variant-id')
    const productUrl = this.getAttribute('data-product-url')
    const productTitle = this.getAttribute('data-product-title')

    if (window.theme?.category?.apiLayer) {
      window.theme.category.apiLayer.productViewed(productId, variantId)
    }

    if (window.theme?.searchAnalytics) {
      window.theme.searchAnalytics.productViewed(
        productId,
        productUrl,
        productTitle,
        variantId,
      )
    }
  }

  handleTouchStart (event) {
    this.swipeIsInsideMediaContainer = false
    this.touchX = event.touches?.[0]?.clientX
    this.touchY = event.touches?.[0]?.clientY
    this.els?.media?.element?.setAttribute('data-touched', 'true')

    const rect = event.target.getBoundingClientRect()
    const y = event.touches?.[0]?.clientY - rect.top

    this.swipeIsInsideMediaContainer = y < this.els.media.element.offsetHeight
  }

  handleTouchMove (event) {
    if (!this.swipeIsInsideMediaContainer) return
    const clientX = event.touches?.[0]?.clientX
    const clientY = event.touches?.[0]?.clientY

    if (!this.isInRange(clientY, this.touchY - 15, this.touchY + 15)) return

    this.previousSwipeDirection = this.currentSwipeDirection

    if (this.touchX && this.touchX !== clientX) {
      // Left swipe
      if (clientX < this.touchX - 30) {
        this.currentSwipeDirection = 'left'
      }

      // Right swipe
      if (clientX > this.touchX + 30) {
        this.currentSwipeDirection = 'right'
      }
    }

    if (this.currentSwipeDirection !== this.previousSwipeDirection) {
      this.updateIndex()
      this.touchX = clientX
      this.touchY = clientY
    }
  }

  updateIndex () {
    if (this.currentSwipeDirection === 'left') {
      this.currentIndex = 1
    } else {
      this.currentIndex = 0
    }
  }

  isInRange (value, first, last) {
    const lower = Math.min(first, last)
    const upper = Math.max(first, last)
    return value >= lower && value <= upper
  }

  set currentIndex (index) {
    this._currentIndex = index
    this.els?.media?.element?.setAttribute('data-index', String(index))
  }

  get currentIndex () {
    return this._currentIndex
  }

  get isInsideCarousel () {
    /* All carousels have the class .keen-slider */
    return !!this.closest('.keen-slider')
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, {
    extends: 'article',
  })
}
